import { i18n } from '@/plugins/i18n'
import { customerStatusVariant, customerStatusStr } from "@/constants/customerStatus";


export default [
    {
        field: 'id',
        title: i18n.t('online-factor.hash_id'),
        sortable: true,
        width: 50,
        textAlign: 'center',
    },
    {
        field: 'real_first_name',
        title: i18n.t('online-factor.title_customer'),
        template: (row) => {
            if (row.real_first_name !== null && row.real_last_name !== null) {
                return '<span dir="ltr">' + row.real_first_name + ' ' + row.real_last_name + '</span>'
            } else if (row.real_first_name) {
                return '<span dir="ltr">' + row.real_first_name + '</span>'
            }
            else {
                return '<span>' + row.legal_business_name + '</span>'
            }
        },
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'mobile',
        title: i18n.t('online-factor.mobile'),
        template: (row) => {
            if (row.mobile !== null) {
                return '<span dir="ltr">' + row.mobile + '</span>'
            } else {
                return '<span dir="ltr">___</span>'
            }
        },
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'email',
        title: i18n.t('online-factor.email'),
        sortable: false,
        template: (row) => {
            if (row.email !== null) {
                return '<span dir="ltr">' + row.email + '</span>'
            } else {
                return '<span dir="ltr">___</span>'
            }
        },
        textAlign: 'center',
    },
    {
        field: 'is_archived',
        title: i18n.t('label.status'),
        template: (row) => {
            let status = customerStatusStr.get(row.is_archived)
            let variant = 'badge-' + customerStatusVariant(row.is_archived)

            return '<div class="badge ' + variant + ' text-white">' + status + '</div>'
        },
        sortable: false,
        textAlign: 'center',
    }
]
export const image_status = (row) => {
    if (row.image == null) {
        return '<div>' + i18n.t('online-factor.without_picture') + '</div>'
    }
    else
        return '<img src="' + row.image + '" width="60"/>'
}
